module.exports = __webpack_public_path__ + "img/IntroductionImage.ebb36d39.jpg";